<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [formGroup]="formStep"
  >
  <div class="form-step__subheading" data-testid="check-in-subheader">
    {{ subHeadingText }}
  </div>

  <h3 [class.title--error]="submissionFailure">
    Review and Acknowledge{{ submissionFailure ? '*' : '' }}
  </h3>

  <div class="consents">
    <div class="consent">
      <mat-checkbox
        class="consent__checkbox"
        data-testid="privacy-policy-checkbox"
        [formControl]="privacyPolicyConsentCheckbox"
        (change)="togglePrivacyPolicyConsentCheckbox()"
        >
        I agree to the
      </mat-checkbox>
      &nbsp;
      <button
        class="consent__link"
        (click)="openPrivacyPolicyConsentModal($event)"
        data-testid="privacy-policy-modal"
        >
        Privacy Policy
      </button>
    </div>

    <div class="consent">
      <mat-checkbox
        class="consent__checkbox"
        data-testid="terms-of-use-checkbox"
        [formControl]="termsOfUseConsentCheckbox"
        (change)="toggleTermsOfUseConsentCheckbox()"
        >
        I agree to the
      </mat-checkbox>
      &nbsp;
      <button
        class="consent__link"
        (click)="openTermsOfUseConsentModal($event)"
        data-testid="terms-of-use-modal"
        >
        Terms of Use
      </button>
    </div>

    @if (isRONOrKRON()) {
      <div class="consent">
        <mat-checkbox
          class="consent__checkbox"
          data-testid="use-of-ai-checkbox"
          [formControl]="useOfAIConsentCheckbox"
          (change)="toggleUseOfAIConsentCheckbox()"
          >
          I agree to the
        </mat-checkbox>
        &nbsp;
        <button
          class="consent__link"
          (click)="openUseOfAIConsentModal($event)"
          data-testid="use-of-ai-modal"
          >
          Use of AI
        </button>
      </div>
    }
    @if (submissionFailure) {
      <p class="consent-error-message">
        Please check all the boxes before continuing.
      </p>
    }
  </div>

  <p class="consent-text">{{ (termsAndConditionsConsent$ | async)?.consentText }}</p>

  <app-button-container>
    <app-button [dataTestId]="'decline-button'" type="tertiary" (buttonClick)="openDeclineModal()">
      Decline
    </app-button>
    <app-button [dataTestId]="'next-button-terms'" type="primary" (buttonClick)="goToNextStep()">
      Accept
    </app-button>
  </app-button-container>
</app-wizard-step-wrapper>
